import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import DbaRegistriesComponent from './shipx-registries.component';


export const DBARegistryDetails = ({ 
    id, handleBacicInnerFormChange, handleInnerFormChange, dbnpname, opsnumber, subDomains, domains, countries, back, handleFormSubmit, selectedDbaRegistry 
  }: any) => {
 const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
      const [searchParams, setSearchParams] = useSearchParams();
  const tabItems = [
    {
      id: 1,
      title: `DBA Registry Details`,
      component:  <DbaRegistriesComponent
      handleInnerFormChange={handleInnerFormChange}
      handleBacicInnerFormChange={handleBacicInnerFormChange}
      selectedDbaRegistry={selectedDbaRegistry}
      back={back}
      handleFormSubmit={handleFormSubmit}
      id={id}
      dbnpname={dbnpname}
      opsnumber={opsnumber}
      domains={domains}
      subDomains={subDomains}
      countries={countries}
  />,
      isVisible: true,
    }, 
  ];

useEffect(() => {
            const tabTitleFromURL = searchParams.get('tab');
            if (tabTitleFromURL) {
                const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
                if (tabIndex !== -1) {
                    setSelectedTabIndex(tabIndex);
                }
            } else {
                setSelectedTabIndex(0);
            }
        }, [searchParams]);
    
        const handleTabChange = (index: number) => {
            setSelectedTabIndex(index);
            setSearchParams({ tab: tabItems[index].title });
        };
    
        if (selectedTabIndex === null) {
            return null;
        }
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
      
      <TabContainer tabItems={tabItems}   selectedIndex={selectedTabIndex}
            onChange={handleTabChange}  />
      <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
             {/* Show Save button only if IsPartnerNetwork is not true */}
        {!selectedDbaRegistry?.IsPartnerNetwork && (
          <button
            onClick={handleFormSubmit}
            type="button"
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
          >
            Save
          </button>
        )}
      </div>
    </div>
  );
};

export default DBARegistryDetails;
